import { render, staticRenderFns } from "./ClientProjectsTableWrapper.vue?vue&type=template&id=12fca687&scoped=true"
import script from "./ClientProjectsTableWrapper.vue?vue&type=script&lang=ts"
export * from "./ClientProjectsTableWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fca687",
  null
  
)

export default component.exports